var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { RouterProvider, createBrowserRouter, useLoaderData, useParams, } from "react-router-dom";
import { ClientComponent, NotFoundComponentContainer, NotFoundPageComponent, ServerComponent, } from "../components/index.js";
import { ErrorBoundary, DefaultLayout } from "../../core/components/index.js";
/**
 * This function receives a router component and get a formated router first
 * and then return a router.
 */
export var getRouter = function (router) {
    var routes = generateBrowserRoutes(router);
    var Router = createBrowserRouter(routes);
    return function () { return (_jsx(RouterProvider, { fallbackElement: _jsx(_Fragment, { children: "Not Found" }), router: Router })); };
};
/**
 * This function receives a router component and return a formated router.
 */
var generateBrowserRoutes = function (router, isRoot) {
    if (isRoot === void 0) { isRoot = true; }
    // Initialization of the list of routes
    var routes = [];
    // Get information about the layout and the path
    var Layout = router.layout;
    var route = {
        path: Layout.path,
        elementError: _jsx(ErrorBoundary, {}),
        Component: function () {
            // Default data
            var defaultData = {
                props: {},
            };
            var props = (useLoaderData() || defaultData).props;
            // get params
            var params = useParams();
            var finalProps = __assign(__assign({}, props), { params: params });
            return _jsx(Layout, __assign({}, finalProps));
        },
        children: [],
    };
    // Defining the page not found route
    if (isRoot) {
        routes.push({
            path: "*",
            element: (_jsx(NotFoundComponentContainer, { content: router.notFoundComponent })),
        });
    }
    // Get informations about pages
    var pages = router.pages.map(function (Page) {
        var pagePathFormated = Page.path[0] === "/" && Page.path !== "/"
            ? Page.path.slice(1)
            : Page.path;
        // Get the path of the page
        var path = Page.path === "/"
            ? Layout.path
            : Layout.path.length > 1
                ? pagePathFormated
                : Page.path;
        return {
            path: path,
            element: (_jsx(ClientComponent, { page: Page, loader: router.loaderComponent({}), layoutMetadata: Layout.metadata })),
            elementError: _jsx(ErrorBoundary, {}),
        };
    });
    // Add pages into children of the current route
    pages.forEach(function (page) {
        route.children.push(page);
    });
    // Loop throug sub routers in order to apply the same thing.
    // for (const SubRouter of router.routers) {
    //   const subRouter = new SubRouter();
    //   const subRoutes = generateBrowserRoutes(subRouter);
    //   // Add sub routes into the lists of route
    //   route.children.push(subRoutes);
    // }
    routes.push(route);
    // Loop throug besides routers in order to apply the same thing.
    for (var _i = 0, _a = router.routers; _i < _a.length; _i++) {
        var besideRouter = _a[_i];
        var besidesRoutes = generateBrowserRoutes(besideRouter, false);
        // Add besides routes into the lists of route
        routes.push.apply(routes, besidesRoutes);
    }
    // Return the formated router
    return routes;
};
/**
 * This function receives a router component and return a formated router for static routing
 * @param router Represents the router component
 * @returns
 */
export var generateStaticRoutes = function (router, isRoot) {
    if (isRoot === void 0) { isRoot = true; }
    // Initialization of the list of routes
    var routes = [];
    // Get information about the layout and the path
    var Layout = router.layout;
    var route = {
        path: Layout.path,
        elementError: _jsx(ErrorBoundary, {}),
        Component: function () {
            // Default data
            var defaultData = {
                props: {},
            };
            // Get SSR data
            var props = (useLoaderData() || defaultData).props;
            // get params
            var params = useParams();
            var finalProps = __assign(__assign({}, props), { params: params });
            return _jsx(Layout, __assign({}, finalProps));
        },
        loader: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var response, formData, error_1;
            var params = _b.params, request = _b.request;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        // Check if the loader is defined
                        if (!Layout.loader) {
                            throw new Error("Missing loader function");
                        }
                        return [4 /*yield*/, Layout.loader({ params: params, request: request })];
                    case 1:
                        response = _c.sent();
                        // Handle redirection
                        if (response.redirect) {
                            formData = new FormData();
                            formData.append("redirect", response.redirect);
                            return [2 /*return*/, new Response(formData, {
                                    status: 302,
                                    headers: {
                                        Location: response.redirect,
                                    },
                                })];
                        }
                        return [2 /*return*/, response];
                    case 2:
                        error_1 = _c.sent();
                        return [2 /*return*/, {
                                props: {},
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
        children: [],
    };
    // Defining the page not found route
    if (isRoot) {
        routes.push({
            path: "*",
            element: (_jsx(NotFoundComponentContainer, { content: router.notFoundComponent })),
        });
    }
    // Get informations about pages
    var pages = router.pages.map(function (Page) {
        var pagePathFormated = Page.path[0] === "/" && Page.path !== "/"
            ? Page.path.slice(1)
            : Page.path;
        // Get the path of the page
        var path = Page.path === "/"
            ? Layout.path
            : Layout.path.length > 1
                ? pagePathFormated
                : Page.path;
        return {
            path: path,
            loader: function (_a) {
                return __awaiter(this, arguments, void 0, function (_b) {
                    var response, formData, error_2;
                    var params = _b.params, request = _b.request;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _c.trys.push([0, 2, , 3]);
                                // Check if the loader is defined
                                if (!Page.loader) {
                                    throw new Error("Missing loader function");
                                }
                                return [4 /*yield*/, Page.loader({ params: params, request: request })];
                            case 1:
                                response = _c.sent();
                                // Handle redirection
                                if (response.redirect) {
                                    formData = new FormData();
                                    formData.append("redirect", response.redirect);
                                    return [2 /*return*/, new Response(formData, {
                                            status: 302,
                                            headers: {
                                                Location: response.redirect,
                                            },
                                        })];
                                }
                                return [2 /*return*/, response];
                            case 2:
                                error_2 = _c.sent();
                                return [2 /*return*/, {
                                        props: {},
                                    }];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
            Component: function () {
                return (_jsx(ServerComponent, { page: Page, loader: router.loaderComponent({}), layoutMetadata: Layout.metadata }));
            },
            elementError: _jsx(ErrorBoundary, {}),
        };
    });
    // Add pages into children of the current route
    pages.forEach(function (page) {
        route.children.push(page);
    });
    // Loop throug sub routers in order to apply the same thing.
    // for (const SubRouter of router.routers) {
    //   const subRouter = new SubRouter();
    //   const subRoutes = generateStaticRoutes(subRouter);
    //   // Add sub routes into the lists of route
    //   route.children.push(subRoutes);
    // }
    routes.push(route);
    // Loop throug besides routers in order to apply the same thing.
    for (var _i = 0, _a = router.routers; _i < _a.length; _i++) {
        var besideRouter = _a[_i];
        var besidesRoutes = generateStaticRoutes(besideRouter, false);
        // Add besides routes into the lists of route
        routes.push.apply(routes, besidesRoutes);
    }
    // Return the formated router
    return routes;
};
/**
 * This function adds metadata to a page or a layout
 * @param option
 * @returns
 */
export var defineRoutePage = function (option) {
    var path = option.path, metadata = option.metadata;
    return function (Component) {
        if (!path)
            throw new Error("You must provide a path to the page");
        // Create a new instance of the component
        var component = new Component();
        // Set properties
        component.path = path;
        component.metadata = metadata;
        return component;
    };
};
/**
 * This function adds metadata to a page or a layout
 * @param option
 * @returns
 */
export var defineRouteLayout = function (option) {
    var path = option.path, metadata = option.metadata;
    return function (Component) {
        if (!path)
            throw new Error("You must provide a path to the layout");
        // Create a new instance of the component
        var component = new Component();
        // Set properties
        component.path = path;
        component.metadata = metadata;
        return component;
    };
};
/**
 * This function adds metadata to a router
 * @param option
 * @returns
 */
export var defineRouter = function (option) {
    var imports = option.imports, layout = option.layout, pages = option.pages, loaderComponent = option.loaderComponent, notFoundComponent = option.notFoundComponent;
    return function (Component) {
        // Handle errors
        if (!option.pages)
            throw new Error("You must provide a list of pages in the router decorator");
        // Create router
        var router = new Component();
        // Set properties
        router.routers = imports || [];
        router.layout = layout || DefaultLayout;
        router.pages = pages;
        router.loaderComponent = loaderComponent || (function () { return null; });
        router.notFoundComponent = notFoundComponent || NotFoundPageComponent;
        return router;
    };
};
/**
 * This function generates metadata useful for pages to show images when sharing on social media
 * @param {Metadata[]} metadatas
 */
export var generateMetadata = function (metadatas) {
    var metadataElements = [];
    metadatas.forEach(function (metadata) {
        var openGraph = metadata.openGraph, twitter = metadata.twitter, links = metadata.links, metaTags = metadata.metaTags;
        // Handling openGraph
        if (openGraph) {
            var title = openGraph.title, description = openGraph.description, url = openGraph.url, image = openGraph.image, width = openGraph.width, height = openGraph.height, type = openGraph.type;
            if (title) {
                metadataElements.push(_jsx("meta", { property: "og:title", content: title }, "og:title"));
            }
            if (description) {
                metadataElements.push(_jsx("meta", { property: "og:description", content: description }, "og:description"));
            }
            if (url) {
                metadataElements.push(_jsx("meta", { property: "og:url", content: url }, "og:url"));
            }
            if (image) {
                metadataElements.push(_jsx("meta", { property: "og:image", content: image }, "og:image"));
            }
            if (width) {
                metadataElements.push(_jsx("meta", { property: "og:image:width", content: width }, "og:image:width"));
            }
            if (height) {
                metadataElements.push(_jsx("meta", { property: "og:image:height", content: height }, "og:image:height"));
            }
            metadataElements.push(_jsx("meta", { property: "og:type", content: type || "website" }, "og:type"));
        }
        // Handling twitter
        if (twitter) {
            var card = twitter.card, site = twitter.site, creator = twitter.creator, image = twitter.image, title = twitter.title, description = twitter.description;
            metadataElements.push(_jsx("meta", { name: "twitter:card", content: card || "summary_large_image" }, "twitter:card"));
            if (site) {
                metadataElements.push(_jsx("meta", { name: "twitter:site", content: site }, "twitter:site"));
            }
            if (creator) {
                metadataElements.push(_jsx("meta", { name: "twitter:creator", content: creator }, "twitter:creator"));
            }
            if (image) {
                metadataElements.push(_jsx("meta", { name: "twitter:image", content: image }, "twitter:image"));
            }
            if (title) {
                metadataElements.push(_jsx("meta", { name: "twitter:title", content: title }, "twitter:title"));
            }
            if (description) {
                metadataElements.push(_jsx("meta", { name: "twitter:description", content: description }, "twitter:description"));
            }
        }
        // Handling links
        if (links) {
            metadataElements.push.apply(metadataElements, generateLinks(links));
        }
        // Handling metadata tags
        if (metaTags) {
            metadataElements.push.apply(metadataElements, generateMetaTags(metaTags));
        }
    });
    return metadataElements;
};
/**
 * This function generates links for metadata
 */
var generateLinks = function (links) {
    return links.map(function (link) {
        var rel = link.rel, sizes = link.sizes, type = link.type, href = link.href;
        return (_jsx("link", { rel: rel, sizes: sizes || "32x32", type: type || "image/png", href: href }, rel));
    });
};
/**
 * This function generates meta tags for metadata
 * @param metaTags
 * @returns
 */
var generateMetaTags = function (metaTags) {
    return metaTags.map(function (metaTag) {
        var content = metaTag.content, name = metaTag.name, property = metaTag.property;
        if (property) {
            return _jsx("meta", { property: property, content: content }, property);
        }
        return _jsx("meta", { name: name, content: content }, name);
    });
};
